import { canDeleteRule } from '../../domain/doctorShiftRule';
import type { DoctorShiftRuleRepository } from './ports/DoctorShiftRuleRepository';

export interface DeleteDoctorShiftRuleInput {
  id: string;
}

export interface DeleteDoctorShiftRuleOutput {
  success: boolean;
  errors?: string[];
}

/**
 * 医師シフトルールを削除するUseCase（論理削除）
 * @param repository DoctorShiftRuleRepository リポジトリインスタンス
 * @param input DeleteDoctorShiftRuleInput 削除対象ID
 * @returns Promise<DeleteDoctorShiftRuleOutput> 削除結果（失敗時: errors）
 */
export async function deleteDoctorShiftRule(
  repository: DoctorShiftRuleRepository,
  input: DeleteDoctorShiftRuleInput
): Promise<DeleteDoctorShiftRuleOutput> {
  // 既存ルール取得
  const existingRule = await repository.findById(input.id);
  if (!existingRule) {
    return { success: false, errors: ['指定されたルールが見つかりません'] };
  }

  // 削除可能チェック
  if (!canDeleteRule(existingRule)) {
    return { success: false, errors: ['このルールは既に削除されています'] };
  }

  await repository.delete(input.id);

  return { success: true };
}
